function sbUpdatePrice(root,price,comparePrice){
 const current=root.querySelector('[data-variant-price]');
 if(!current)return;
 const discounted=Boolean(comparePrice);
 current.textContent=price;
 current.classList.toggle('sale-price',discounted);
 current.setAttribute('aria-label',(discounted?'Sale price: ':'Price: ')+price);
 const original=root.querySelector('[data-variant-compare]');
 if(original){original.textContent=comparePrice||'';original.hidden=!discounted;original.setAttribute('aria-label','Original price: '+(comparePrice||''));}
 const badge=root.querySelector('[data-variant-sale]');
 if(badge)badge.hidden=!discounted;
}
document.addEventListener('click',event=>{
 const toggle=event.target.closest('[data-menu-toggle]');if(toggle){const nav=document.getElementById(toggle.getAttribute('aria-controls'));nav.classList.toggle('open');toggle.setAttribute('aria-expanded',nav.classList.contains('open'))}
 const tab=event.target.closest('[data-tab]');if(tab){const root=tab.closest('[data-collection-tabs]');root.querySelectorAll('[data-tab]').forEach(b=>{b.classList.toggle('active',b===tab);b.setAttribute('aria-pressed',b===tab)});root.querySelectorAll('[data-tab-panel]').forEach(p=>{p.hidden=p.dataset.tabPanel!==tab.dataset.tab})}
 const swatch=event.target.closest('[data-match-option]');if(swatch){const root=swatch.closest('[data-matching-feature]');root.querySelectorAll('[data-match-option]').forEach(b=>{b.classList.toggle('active',b===swatch);b.setAttribute('aria-pressed',b===swatch)});const image=root.querySelector('.portrait-frame img');if(image&&swatch.dataset.image){image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=swatch.dataset.image;image.alt=swatch.dataset.title}root.querySelector('[data-match-title]').textContent=swatch.dataset.title;root.querySelector('[data-match-price]').textContent=swatch.dataset.price;root.querySelector('[data-match-link]').href=swatch.dataset.url}
});
document.addEventListener('change',event=>{const select=event.target.closest('[data-variant-select]');if(select){const root=select.closest('[data-product-form]'),option=select.selectedOptions[0],button=root.querySelector('[data-add-button]');sbUpdatePrice(root,option.dataset.price,option.dataset.comparePrice);button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Sold out':button.dataset.label;const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url)}const sort=event.target.closest('[data-sort-select]');if(sort)sort.form.requestSubmit()});
document.addEventListener('shopify:block:select',event=>{const b=event.target;const tab=b.matches('[data-tab]')?b:b.querySelector('[data-tab]');if(tab)tab.click();const swatch=b.matches('[data-match-option]')?b:b.querySelector('[data-match-option]');if(swatch)swatch.click()});

(function(){
 const media=window.matchMedia('(max-width:860px)');
 function closeMenus(returnFocus){
  document.querySelectorAll('[data-menu-toggle][aria-expanded="true"]').forEach(toggle=>{
   const nav=document.getElementById(toggle.getAttribute('aria-controls'));
   if(nav)nav.classList.remove('open');
   toggle.setAttribute('aria-expanded','false');
   toggle.setAttribute('aria-label','Open menu');
   if(returnFocus)toggle.focus();
  });
 }
 document.addEventListener('click',event=>{
  const toggle=event.target.closest('[data-menu-toggle]');
  if(toggle){toggle.setAttribute('aria-label',toggle.getAttribute('aria-expanded')==='true'?'Close menu':'Open menu');return;}
  if(event.target.closest('.sb-header nav a')||!event.target.closest('.sb-header'))closeMenus(false);
 });
 document.addEventListener('keydown',event=>{if(event.key==='Escape')closeMenus(true);});
 media.addEventListener('change',()=>closeMenus(false));
 document.addEventListener('shopify:section:unload',()=>closeMenus(false));
})();
(function(){
 function initialize(root){
  const source=root.querySelector('[data-option-variants]');
  const picker=root.querySelector('[data-option-picker]');
  const fallback=root.querySelector('[data-variant-fallback]');
  if(!source||!picker||!fallback)return;
  try{JSON.parse(source.textContent);}catch{return;}
  picker.hidden=false;
  fallback.hidden=true;
  root.dataset.optionsInitialized='true';
  update(root,false);
 }
 function update(root,change){
  const variants=JSON.parse(root.querySelector('[data-option-variants]').textContent);
  const fields=[...root.querySelectorAll('[data-option-index]')];
  const selections=fields.map(f=>f.querySelector('input:checked')?.value);
  const original=root.querySelector('[data-variant-select]');
  const variant=fields.length?variants.find(v=>v.options.every((value,i)=>value===selections[i])):variants.find(v=>String(v.id)===original.value);
  const button=root.querySelector('[data-add-button]');
  const status=root.querySelector('[data-variant-status]');
  const checkout=root.querySelector('.shopify-payment-button');
  fields.forEach((field,index)=>{
   field.querySelectorAll('input').forEach(input=>{
    const available=variants.some(v=>v.available&&v.options[index]===input.value&&v.options.every((value,i)=>i===index||value===selections[i]));
    const label=input.nextElementSibling;
    label.classList.toggle('is-unavailable',!available);
    label.title=available?'':'Unavailable with the other selected sizes';
   });
  });
  if(variant){
   original.disabled=false;
   original.value=String(variant.id);
   if(change)original.dispatchEvent(new Event('change',{bubbles:true}));
   sbUpdatePrice(root,variant.price,variant.comparePrice);
   button.disabled=!variant.available;
   button.textContent=variant.available?button.dataset.label:'Sold out';
   status.textContent=variant.available?'':'This size combination is sold out. Please try another size.';
  }else{
   original.disabled=true;
   sbUpdatePrice(root,'—',null);
   button.disabled=true;
   button.textContent='Unavailable';
   status.textContent='This size combination is unavailable. Please choose another combination.';
   if(change){const url=new URL(window.location.href);url.searchParams.delete('variant');window.history.replaceState({},'',url);}
  }
  if(checkout)checkout.hidden=!variant?.available;
 }
 function scan(scope){scope.querySelectorAll('[data-product-form]').forEach(initialize);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document));else scan(document);
 document.addEventListener('shopify:section:load',event=>scan(event.target));
 document.addEventListener('change',event=>{if(event.target.matches('[data-product-option]')){const root=event.target.closest('[data-product-form]');if(root?.dataset.optionsInitialized==='true')update(root,true);}});
})();
(function(){
 function initialize(root){
  if(root.dataset.galleryReady)return;
  const slides=[...root.querySelectorAll('[data-gallery-slide]')];
  if(!slides.length)return;
  root.dataset.galleryReady='true';
  const dialog=root.querySelector('[data-gallery-dialog]');
  const stage=root.querySelector('[data-gallery-enlarged]');
  const images=slides.map((slide,index)=>slide.querySelector('[data-gallery-open]')?index:null).filter(index=>index!==null);
  let index=0,opener=null,suppressClickUntil=0;
  function enlarge(){
   const source=slides[index].querySelector('[data-gallery-open]');
   if(!source)return;
   const image=source.querySelector('img').cloneNode(true);
   image.removeAttribute('srcset');image.removeAttribute('sizes');image.loading='eager';image.src=source.dataset.galleryFullSrc;
   stage.replaceChildren(image);
   root.querySelector('[data-lightbox-count]').textContent=(images.indexOf(index)+1)+' / '+images.length;
   root.querySelectorAll('[data-lightbox-step]').forEach(button=>button.disabled=images.length<2);
  }
  function show(next){
   const previous=slides[index];
   previous.querySelectorAll('video').forEach(video=>video.pause());
   index=(next+slides.length)%slides.length;
   slides.forEach((slide,i)=>slide.hidden=i!==index);
   root.querySelectorAll('[data-gallery-index]').forEach(button=>button.setAttribute('aria-pressed',Number(button.dataset.galleryIndex)===index));
   const count=root.querySelector('[data-gallery-count]');if(count)count.textContent=(index+1)+' / '+slides.length;
   if(dialog.open)enlarge();
  }
  function step(amount){if(dialog.open){const position=images.indexOf(index);show(images[(position+amount+images.length)%images.length]);}else show(index+amount);}
  root.querySelectorAll('[data-gallery-controls],[data-gallery-thumbnails]').forEach(element=>element.hidden=false);
  root.addEventListener('click',event=>{
   if(Date.now()<suppressClickUntil){event.preventDefault();return;}
   const thumbnail=event.target.closest('[data-gallery-index]');if(thumbnail){show(Number(thumbnail.dataset.galleryIndex));return;}
   const nav=event.target.closest('[data-gallery-step],[data-lightbox-step]');if(nav){step(Number(nav.dataset.galleryStep||nav.dataset.lightboxStep));return;}
   const photo=event.target.closest('[data-gallery-open]');if(photo&&typeof dialog.showModal==='function'){opener=photo;enlarge();dialog.showModal();return;}
   if(event.target.closest('[data-gallery-close]')||event.target===dialog)dialog.close();
  });
  root.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){if(event.target.closest('video,iframe,model-viewer'))return;event.preventDefault();step(event.key==='ArrowLeft'?-1:1);}});
  dialog.addEventListener('close',()=>{stage.replaceChildren();if(opener){const visible=slides[index].querySelector('[data-gallery-open]');(visible||opener).focus();}});
  for(const area of [root.querySelector('[data-gallery-track]'),stage]){
   let origin=null;
   area.addEventListener('pointerdown',event=>{if(event.pointerType==='mouse'||event.target.closest('video,iframe,model-viewer'))return;origin={x:event.clientX,y:event.clientY};});
   area.addEventListener('pointercancel',()=>origin=null);
   area.addEventListener('pointerup',event=>{if(!origin)return;const dx=event.clientX-origin.x,dy=event.clientY-origin.y;origin=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5){suppressClickUntil=Date.now()+400;step(dx<0?1:-1);}});
  }
  show(0);
 }
 function scan(scope){scope.querySelectorAll('[data-product-gallery]').forEach(initialize);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document));else scan(document);
 document.addEventListener('shopify:section:load',event=>scan(event.target));
})();

// Native cart submissions keep totals, discounts, notes and checkout in sync.
(()=>{
 function initializeCart(form){
  if(form.dataset.cartInitialized)return;
  form.dataset.cartInitialized='true';
  const update=form.querySelector('[data-cart-update]');
  function submitUpdate(){
   if(!form.reportValidity())return;
   if(form.dataset.cartUpdating)return;
   form.dataset.cartUpdating='true';
   const status=form.querySelector('[data-cart-status]');
   if(status)status.textContent='Updating your cart…';
   form.requestSubmit(update);
  }
  form.addEventListener('click',event=>{
   const button=event.target.closest('[data-cart-step]');
   if(!button||!form.contains(button))return;
   const input=button.closest('[data-cart-quantity]').querySelector('input');
   const next=Math.max(0,(Number(input.value)||0)+Number(button.dataset.cartStep));
   if(next===Number(input.value))return;
   input.value=String(next);
   submitUpdate();
  });
  form.addEventListener('change',event=>{if(event.target.matches('input[name="updates[]"]'))submitUpdate();});
 }
 function scan(scope){scope.querySelectorAll('[data-cart-form]').forEach(initializeCart);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document));else scan(document);
 document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
